import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

import { useGlobalContext } from '../../AppContext';
import { BigButton } from '../../components/BigButton';
import { BigMenu } from '../../components/BigMenu';
import { treeMapOptions } from './graphData';

import './HeatMap.scss';

export function HeatMap() {
  const { isMobile, config } = useGlobalContext();

  const [heatMapData, setHeatMapData] = useState<any>();
  const [selectedType, setSelectedType] = useState<string>('portfolio');
  // render graphs
  useEffect(() => {
    if (config && config.networks) {
      if (isMobile) {
        treeMapOptions.dataLabels.style.fontSize = '7px';
      }
      console.log(config.heatMapMarket);
      if (selectedType === 'market') {
        setHeatMapData([
          {
            data: config.heatMapMarket.map((item: any) => {
              if (Math.abs(item.change) > 2) {
                console.log(Math.abs(item.change));
                return { x: item.symbol.toUpperCase(), y: item.change };
              }
            }),
          },
        ]);
      } else {
        setHeatMapData([
          {
            data: config.heatMapPortfolio.map((item: any) => {
              if (Math.abs(item.change) > 2)
                return { x: item.symbol.toUpperCase(), y: item.change };
            }),
          },
        ]);
      }
    } else {
      setHeatMapData(false);
    }
  }, [config, selectedType]);

  return (
    <>
      <div className="heat-map">
        <BigMenu horizontal={true} />
        {isMobile ? (
          <svg
            width="0"
            height="0"
            viewBox="0 0 305 205"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <clipPath id="myClip">
              <path
                d="M 80.772 197.669 L 72.442 202.852 L 21.335 202.738 L 7.701 167.573 L 11.728 160.668 L 11.891 55.278 L 15.006 49.04 L 14.598 6.271 L 135.405 6.114 L 141.491 9.947 L 221.699 9.826 L 228.701 6.303 L 292.451 6.458 L 300.513 16.663 L 300.208 107.004 L 296.851 114.757 L 296.108 191.949 L 291.168 198.674 L 80.772 197.669 Z"
                stroke="#50617B"
              />
            </clipPath>
          </svg>
        ) : (
          <svg
            width="0"
            height="0"
            viewBox="0 0 945 642"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <clipPath id="myClip">
              <path
                d="M 239.817 614.601 L 213.357 631.068 L 51.011 630.705 L 7.701 519 L 20.492 497.066 L 21.01 162.287 L 30.907 142.471 L 29.611 6.613 L 413.363 6.114 L 432.696 18.291 L 687.482 17.907 L 709.725 6.715 L 912.231 7.207 L 937.839 39.625 L 936.872 326.598 L 926.208 351.226 L 923.847 596.433 L 908.156 617.795 L 239.817 614.601 Z"
                stroke="#50617B"
              />
            </clipPath>
          </svg>
        )}

        <div className="button-container mt-5">
          <div onClick={() => setSelectedType('portfolio')}>
            <BigButton
              name="Portfolio"
              type={`${selectedType === 'portfolio' ? 'light' : 'dark'}`}
            />
          </div>
          <div onClick={() => setSelectedType('market')}>
            <BigButton name="Market" type={`${selectedType === 'market' ? 'light' : 'dark'}`} />
          </div>
        </div>
        <div className="heat-map-container">
          <div className="heat-map-chart mt-5">
            {config && heatMapData && (
              <ReactApexChart
                options={treeMapOptions}
                series={heatMapData}
                type="treemap"
                width={isMobile ? 320 : 945}
                height={isMobile ? 230 : 660}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
